import { useState } from 'react'
import PropTypes from 'prop-types'
import parser from 'html-react-parser'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'

interface TooltipWithParserProps {
    title: string; // Define props type if needed
  }

  export const TooltipWithParser = ({ title }: TooltipWithParserProps) => {
    const [showTooltip, setShowTooltip] = useState(false)
    const customization = useSelector((state: RootState) => state.customization)
    return (
        <div className="relative inline-block mx-1">
            <div
                className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-lg ${showTooltip ? 'block' : 'hidden'}`}
                style={{ whiteSpace: 'pre-wrap' }}
            >
                {title}
            </div>
            <button
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                className="flex items-center justify-center h-3 w-3 p-0 rounded-full border-none bg-gray-300"
                style={{
                    color: customization.isDarkMode ? 'white' : 'inherit',
                }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="icon icon-tabler icons-tabler-filled icon-tabler-help-octagon">
  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  <path d="M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.897 14a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z" />
</svg>
            </button>
        </div>
    )
}

TooltipWithParser.propTypes = {
    title: PropTypes.node,
    style: PropTypes.any
}
